var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-container" }, [
    _c("div", { staticClass: "main-container__icon" }, [
      _vm.infoType === "loading"
        ? _c("div", { staticClass: "main-container__icon__loader" })
        : _c("img", {
            staticClass: "main-container__icon__success-icon",
            attrs: { src: _vm.icons.checkGreen },
          }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main-container__message" }, [
      _vm._v("\n    " + _vm._s(_vm.message) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }